import { Cancel } from '@mui/icons-material';
import { Dialog, Grid } from '@mui/material';
import { Box, Container, useTheme } from '@mui/system';
import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import { ServiceProfesionalForm } from './ServiceProfesionalForm';

export const ServiceProfesionalModal = ({ open, onClose, formikRef, setLoading, setSnackbarData }) => {
  const theme = useTheme();

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth={'md'} fullWidth>
        <MainCard
          title={'Agregar Servicios Profesionales'}
          secondary={
            <Grid container justifyContent={'center'}>
              <Box>
                <Cancel sx={{ fontSize: '40px' }} color={theme.palette.grey[500]} onClick={onClose} />
              </Box>
            </Grid>
          }
        >
          <Container maxWidth="md" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ServiceProfesionalForm formikRef={formikRef} setLoading={setLoading} setSnackbarData={setSnackbarData} />
          </Container>
        </MainCard>
      </Dialog>
    </>
  );
};
